import React = require("react");
import {AppTranslations} from "../../components/Utils/translations/AppTranslations";
import "./PredictiveMaintenanceQuestionaire.scss";
import {TerminalAddAlarmNotePanel} from "./PredictiveMaintenanceTerminalDummyWorkOrderNode";

declare var AppTranslations: AppTranslations;

interface PredictiveMaintenanceTerminalNodeProps {
    fault: string;
    openWorkOrder: () => void;
    alarmData: any;
    alarmPanel: any;
}

export class PredictiveMaintenanceTerminalNode extends React.Component<PredictiveMaintenanceTerminalNodeProps, any> {
    constructor(props: PredictiveMaintenanceTerminalNodeProps) {
        super(props);
    }

    public openPredictiveWorkOrder = () => {
        this.props.openWorkOrder();
    }

    public render() {
        return (
            <div className="alarmPanelQuestion">
                {!this.props.alarmData.useDummyWorkOrder ? <div id="alarmPanelTerminalQuestionOpenWorkOrderTemplate">
                    <div className="alarmPanelQuestionMarginContent">
                        <div className="alarm-panel-question-terminal-node"/>
                    </div>
                    {/* tslint:disable-next-line:max-line-length */}
                    <div className="alarmPanelQuestionMarginContent alarmPanelQuestionRightMarginContent alarmPanelTerminalQuestionWork">
                        <div className="verticalAlign"/>
                        <div
                            id="openWorkAlarmPredictive"
                            className="alarmDetailButtonWrapper"
                            onClick={this.openPredictiveWorkOrder}
                        >
                            <div
                                className="alarmDetailButton alarm-detail-button"
                            >
                                <div className="onButton">
                                    <div className="icon alarmOpenWorkOrderIcon"/>
                                </div>
                                <div className="icon alarmOpenWorkOrderIcon"/>
                            </div>
                            <p style={{marginLeft: "5px"}}>
                                {AppTranslations.predictiveTranslation.openWorkOrderTitle}<br/>
                            </p>
                        </div>
                        <div className="alarmTerminateWorkOrderHints" style={{textAlign: "left"}}>
                            <p style={{marginTop: "5px"}}>
                                {AppTranslations.predictiveTranslation.possibleHints}:
                            </p>
                            <ol className="terminalWorkOrderHintElement">
                                <li> {this.props.fault}</li>
                            </ol>
                        </div>
                    </div>
                </div> : <TerminalAddAlarmNotePanel
                    alarmGuid={this.props.alarmData.alarmGuid}
                    alarmPanel={this.props.alarmPanel}
                />}
            </div>
        );
    }
}
